import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

export function useCampaignActionsEnabled(): boolean {
	const {
		data: {
			featureConfigs: { campaignActionsPageConfig },
		},
	} = usePetitionDetailsPageData();
	return Boolean(campaignActionsPageConfig?.enabled);
}
